import {
  RoslizeniE,
  StatistikyStatusCertifikatuE,
  StatistikyStatusOpravneniE,
  StatusCertifikatuE,
  StatusCiselnikuE,
  StatusOpravneniE,
  StatusReklamaceE,
  StatusSablonyE,
  StatusSkupinySablonE,
  StatusSouboruE,
  StavReklamaceE,
  TypDokladuE,
  TypOpravneniStatistikyE,
  TypSablonyE,
  TypZmenyEditE,
  ZobrazeniE,
  ZpochybneniE,
} from '@generated/be';
import { StatusLabel } from '@shared/utils';

export const binaryStatusLabels: Record<'false' | 'true', StatusLabel> = {
  true: {
    label: 'Ano',
    iconName: 'pi pi-check',
    iconColor: 'var(--icon-success)',
  },

  false: {
    label: 'Ne',
    iconName: 'pi pi-times',
    iconColor: 'var(--icon-error)',
  },
};

export const opravneniStatuses: Record<StatusOpravneniE, StatusLabel> = {
  PLATNE: {
    label: 'Platné',
    severity: 'success',
  },
  NEPLATNE: {
    label: 'Neplatné',
    severity: 'danger',
  },
};

export const PublicSablonyTypStatuses: Record<TypSablonyE, StatusLabel> = {
  IMPL_ZZ: {
    label: 'Implicitní ze zákona',
  },
  IMPL_NZRA: {
    label: 'Implicitní na základě rozhodnutí',
  },
  EXPL: {
    label: 'Explicitní',
  },
};

export const opravneniStatusesOptions: Record<StatistikyStatusOpravneniE, StatusLabel> = {
  PLATNE: {
    label: 'Platné',
    severity: 'success',
  },
  NEPLATNE: {
    label: 'Neplatné',
    severity: 'danger',
  },
  ARCHIVOVANE: {
    label: 'Archivované',
    severity: 'contrast',
  },
};

export const opravneniPoctuTypesOptions = [
  {
    id: TypOpravneniStatistikyE.ImplZz,
    label: 'Implicitní ze zákona',
  },
  {
    id: TypOpravneniStatistikyE.ImplNzra,
    label: 'Implicitní na základě rozhodnutí OVM',
  },
  {
    id: TypOpravneniStatistikyE.Expl,
    label: 'Explicitní',
  },
  {
    id: TypOpravneniStatistikyE.Prezidialni,
    label: 'Prezidiální',
  },
  {
    id: TypOpravneniStatistikyE.Vse,
    label: 'Vše',
  },
];

export const rozliseniDatStatistikyOptions = [
  {
    id: RoslizeniE.Auto,
    label: 'Automaticky',
  },
  {
    id: RoslizeniE.Hodina1,
    label: '1 hodina',
  },
  {
    id: RoslizeniE.Den1,
    label: '1 den',
  },
];

export const zobrazeniDatStatistikyOptions = [
  {
    id: ZobrazeniE.ZmenaVCase,
    label: 'Změna v čase',
  },
  {
    id: ZobrazeniE.CelkovyPocetVSystemu,
    label: 'Celkový počet v systému',
  },
];

export const opravneniZmenyOptions: Record<TypZmenyEditE, StatusLabel> = {
  ZAPIS: {
    label: 'Zápis',
  },
  UKONCENI: {
    label: 'Ukončení',
  },
  ZMENA: {
    label: 'Změna',
  },
};

export const opravneniZmenyTypesOptions = [
  {
    id: TypOpravneniStatistikyE.ImplZz,
    label: 'Implicitní ze zákona',
  },
  {
    id: TypOpravneniStatistikyE.ImplNzra,
    label: 'Implicitní na základě rozhodnutí OVM',
  },
  {
    id: TypOpravneniStatistikyE.Expl,
    label: 'Explicitní',
  },
  {
    id: TypOpravneniStatistikyE.Prezidialni,
    label: 'Prezidiální',
  },
  {
    id: TypOpravneniStatistikyE.Vse,
    label: 'Vše',
  },
];

export const rozliseniDatStatistikyZmenyOptions = [
  {
    id: RoslizeniE.Auto,
    label: 'Automaticky',
  },
  {
    id: RoslizeniE.Hodina1,
    label: '1 hodina',
  },
  {
    id: RoslizeniE.Den1,
    label: '1 den',
  },
];

export const zobrazeniDatStatistikyZmenyOptions = [
  {
    id: ZobrazeniE.ZmenaVCase,
    label: 'Změna v čase',
  },
  {
    id: ZobrazeniE.CelkovyPocetVSystemu,
    label: 'Celkový počet v systému',
  },
];

export const rozliseniDatStatistikySablonOptions = [
  {
    id: RoslizeniE.Auto,
    label: 'Automaticky',
  },
  {
    id: RoslizeniE.Hodina1,
    label: '1 hodina',
  },
  {
    id: RoslizeniE.Den1,
    label: '1 den',
  },
];

export const zobrazeniDatStatistikySablonOptions = [
  {
    id: ZobrazeniE.ZmenaVCase,
    label: 'Změna v čase',
  },
  {
    id: ZobrazeniE.CelkovyPocetVSystemu,
    label: 'Celkový počet v systému',
  },
];

export const certifikatyStatuses: Record<StatistikyStatusCertifikatuE, StatusLabel> = {
  PLATNY: {
    label: 'Platný',
    severity: 'success',
  },
  NEPLATNY: {
    label: 'Neplatný',
    severity: 'danger',
  },
  ARCHIVOVANY: {
    label: 'Archivovaný',
    severity: 'contrast',
  },
};

export const rozliseniDatStatistikyCertifikatyOptions = [
  {
    id: RoslizeniE.Auto,
    label: 'Automaticky',
  },
  {
    id: RoslizeniE.Hodina1,
    label: '1 hodina',
  },
  {
    id: RoslizeniE.Den1,
    label: '1 den',
  },
];

export const zobrazeniDatStatistikyCertifikatyOptions = [
  {
    id: ZobrazeniE.ZmenaVCase,
    label: 'Změna v čase',
  },
  {
    id: ZobrazeniE.CelkovyPocetVSystemu,
    label: 'Celkový počet v systému',
  },
];

export const sablonyStatuses: Record<StatusSablonyE, StatusLabel> = {
  [StatusSablonyE.Aktivni]: {
    label: 'Aktivní',
    severity: 'success',
  },
  [StatusSablonyE.Archivovana]: {
    label: 'Archivovaná',
    severity: 'contrast',
  },
  [StatusSablonyE.CekaNaPublikaci]: {
    label: 'Čeká na publikaci',
    severity: 'info',
  },
  [StatusSablonyE.CekaNaSchvaleni]: {
    label: 'Čeká na schválení',
    severity: 'info',
  },
  [StatusSablonyE.Neaktivni]: {
    label: 'Neaktivní',
    severity: 'contrast',
  },
  [StatusSablonyE.Rozpracovana]: {
    label: 'Rozpracovaná',
    severity: 'info',
  },
  [StatusSablonyE.Schvalena]: {
    label: 'Schválená',
    severity: 'success',
  },
  [StatusSablonyE.VracenaKDopracovani]: {
    label: 'Vrácena k dopracování',
    severity: 'warn',
  },
  [StatusSablonyE.Publikovana]: {
    label: 'Publikovaná',
    severity: 'success',
  },
  [StatusSablonyE.Smazana]: {
    label: 'Smazaná',
    severity: 'contrast',
  },
  [StatusSablonyE.VPriprave]: {
    label: 'V přípravě',
    severity: 'info',
  },
  [StatusSablonyE.VracenaKPriprave]: {
    label: 'Vrácena k přípravě',
    severity: 'warn',
  },
  [StatusSablonyE.CekaNaPredschvaleni]: {
    label: 'Čeká na předschválení',
    severity: 'info',
  },
  [StatusSablonyE.DokumentaceNahrana]: {
    label: 'Dokumentace nahrána',
    severity: 'info',
  },
};

export const statusSkupinySablonOptions: Record<StatusSkupinySablonE, StatusLabel> = {
  AKTIVNI: {
    label: 'Aktivní',
    severity: 'success',
  },
  NEAKTIVNI: {
    label: 'Neaktivní',
    severity: 'contrast',
  },
};

export const reklamaceStatuses: Record<StatusReklamaceE, StatusLabel> = {
  PRIJATA: {
    label: 'Přijatá',
    severity: 'info',
  },
  CEKA_NA_RESENI: {
    label: 'Čeká na řešení',
    severity: 'info',
  },
  ROZPRACOVANA: {
    label: 'Rozpracovaná',
    severity: 'info',
  },
  SCHVALENA: {
    label: 'Schválená',
    severity: 'success',
  },
  ZAMITNUTA: {
    label: 'Zamítnutá',
    severity: 'danger',
  },
  VYRESENA: {
    label: 'Vyřešená',
    severity: 'success',
  },
};

export const ciselnikyStatuses: Record<StatusCiselnikuE, StatusLabel> = {
  AKTIVNI: {
    label: 'Aktivní',
    severity: 'success',
  },
  CEKA_NA_VYJADRENI: {
    label: 'Čeká na vyjádření',
    severity: 'info',
  },
  NEAKTIVNI: {
    label: 'Neaktivní',
    severity: 'contrast',
  },
  NESCHVALENA: {
    label: 'Neschválený',
    severity: 'danger',
  },
};

export const reklamaceStates: Record<StavReklamaceE, StatusLabel> = {
  PRIJATA: {
    label: 'Přijatá',
    severity: 'info',
  },
  ODESLANA: {
    label: 'Odeslaná',
    severity: 'info',
  },
  ZPRACOVANA: {
    label: 'Zpracovaná',
    severity: 'success',
  },
  CHYBA_V_ZPRACOVANI: {
    label: 'Chyba v zpracování',
    severity: 'danger',
  },
};

export const documentDetailStatusLabels: Record<StatusSouboruE, StatusLabel> = {
  PLATNY: {
    label: 'Platný',
    severity: 'success',
  },
  NEPLATNY: {
    label: 'Neplatný',
    severity: 'danger',
  },
};

export const certifikatStatusLabels: Record<StatusCertifikatuE, StatusLabel> = {
  PLATNY: {
    label: 'Platný',
    severity: 'success',
  },
  NEPLATNY: {
    label: 'Neplatný',
    severity: 'danger',
  },
};

// export const statuses: Record<StatusOpravneniE, StatusLabel> =
export const druhDokladuTotoznosti: Record<TypDokladuE, StatusLabel> = {
  ID: {
    label: 'Id',
  },
  P: {
    label: 'Cestovní pas',
  },
  IR: {
    label: 'Ir',
  },
  VS: {
    label: 'Ir',
  },
  PS: {
    label: 'Ir',
  },
  OP: {
    label: 'Občanský průkaz',
  },
};

export const stavDokladuTotoznosti: Record<ZpochybneniE, StatusLabel> = {
  SPRAVNY: {
    label: 'Správný',
  },
  NESPRAVNY: {
    label: 'Nesprávný',
  },
  NEDEFINOVANY: {
    label: 'Nedefinovaný',
  },
  NESPRAVNY_TVAR: {
    label: 'Nesprávný tvar',
  },
};

export const spravnostUdaje: Record<ZpochybneniE, StatusLabel> = {
  SPRAVNY: {
    label: 'Správný',
  },
  NESPRAVNY: {
    label: 'Nesprávný',
  },
  NEDEFINOVANY: {
    label: 'Nedefinovaný',
  },
  NESPRAVNY_TVAR: {
    label: 'Nesprávný tvar',
  },
};
